import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  NgZone,
  OnInit,
  inject,
  input,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { GlobalErrorStateMatcher } from '../../misc/helpers';
import { startWith } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[ui-input-errors]',
  templateUrl: './input-errors.component.html',
  styleUrls: ['./input-errors.component.scss'],
  standalone: true,
  imports: [CommonModule, MatInputModule],
  // Load-bearing, and the one component here that genuinely cannot be OnPush: the template
  // renders `control()?.errors`, and `errors` is a plain mutable property on AbstractControl
  // rather than a signal, so nothing marks this component dirty when validity changes. OnPush
  // would silently break every validation message in all three apps. The real fix is to derive
  // the errors off `control.statusChanges` into a signal; tracked as a follow-up.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class InputErrorsComponent implements OnInit {
  el = inject(ElementRef);
  destroy = inject(DestroyRef);
  zone = inject(NgZone);

  fieldName = input<string | undefined>();
  regexMessage = input<string | undefined>();
  matField = input<boolean>(true);
  control = input<AbstractControl | undefined>();

  /**
   * Der marker ist nötig, wenn das mat-error element außerhalb eines
   * mat-form-fields verwendet wird. Denn das Form-field prüft selbst, wenn die Fehler angezeigt
   * werden soll. Wenn wir kein mat-form-field nutzen, muss die directive selbst entscheiden, ob diese
   * anhand der control angezeigt werden soll.
   */

  ngOnInit() {
    const control = this.control();

    if (!control) {
      throw new Error('InputErrorsComponent: `control` input is required');
    }

    if (!this.matField()) {
      control.statusChanges
        .pipe(startWith(control.status), takeUntilDestroyed(this.destroy))
        .subscribe(() => {
          const display = new GlobalErrorStateMatcher().isErrorState(control);
          this.el.nativeElement.style.display = display ? 'block' : 'none';
        });
    }
  }
}
